import { render } from "./integration_documentation_section.vue?vue&type=template&id=1a63c682"
import script from "./integration_documentation_section.vue?vue&type=script&lang=js"
export * from "./integration_documentation_section.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__